module.exports = __webpack_public_path__ + "img/loader.f5acdf2c.svg";